import React, { useState } from "react";
import CarTopdown from "../assets/img/car-topdown.png";
import { FileInput } from "../component/Inputs";

const CarImageForm = (props) => {
  return (
    <div className="grid grid-rows-3 grid-cols-3 gap-1 max-w-screen">
      <div>&nbsp;</div>
      <div className="flex items-center justify-center">
        <FileInput
          name="car_front"
          label="front"
          onChange={({ converted }) =>
            props.set({ ...props.get, car_front: converted })
          }
        />
      </div>
      <div>&nbsp;</div>
      <div className="flex items-center justify-center">
        <FileInput
          name="car_left"
          label="left"
          onChange={({ converted }) =>
            props.set({ ...props.get, car_left: converted })
          }
        />
      </div>
      <div className="flex items-center justify-center py-8">
        <img className="-rotate-90" src={CarTopdown} alt="" width={150} />
      </div>
      <div className="flex items-center justify-center">
        <FileInput
          name="car_right"
          label="right/driver"
          onChange={({ converted }) =>
            props.set({ ...props.get, car_right: converted })
          }
        />
      </div>
      <div>&nbsp;</div>
      <div className="flex items-center justify-center">
        <FileInput
          name="car_back"
          label="back"
          onChange={({ converted }) =>
            props.set({ ...props.get, car_back: converted })
          }
        />
      </div>
      <div>&nbsp;</div>
    </div>
  );
};

export default CarImageForm;
